<template>
  <div class="animated fadeIn">
      <spinner v-if="loading"/>
    <b-card>
        <div slot="header">
            <strong>Search Sales Cancellation</strong>
        </div>
        <b-row>
            <b-col sm="3">
                <b-form-group>
                    <label>Credit Note No</label>
                      <wscLookup v-bind:url="apiWscLookUp" v-on:selected="setWsc($event)" :lookupId="filter.credit_note_number"/>
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group>
                    <label for="country_id">Country</label>
                    <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                  <label for="date_start">Date Start</label>
                      <b-form-input type="date" v-model="filter.from_date"></b-form-input>
              </b-form-group>
            </b-col>
          <b-col sm="2">
              <b-form-group>
                  <label for="date_end">Date End</label>
                      <b-form-input type="date" v-model="filter.to_date"></b-form-input>
              </b-form-group>
          </b-col>
          <b-col sm="2">
            <b-form-group>
              <label for="status">Status</label>
                  <b-form-select id="status" v-model="filter.cancellation_status_name"
                      :plain="true"
                      :options="['','PENDING', 'COMPLETED']"
                      value="">
                  </b-form-select>
          </b-form-group>
        </b-col>
        </b-row>
        <div slot="footer">
            <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
            &nbsp;&nbsp;
            <b-button type="submit" size="lg" variant="success" @click="newWSC">New Sales Cancellation</b-button>
        </div>
    </b-card>
    <b-row v-if="getRowCount(searchResults) > 0 && !loading">
        <b-col sm="12" >
          <b-card>
              <div slot="header">
                  <strong>Search Results</strong>
              </div>
              <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
              :per-page="perPage" :items="searchResults" @row-clicked="rowClick">
              </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
            <div slot="footer">
                <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data   = "searchResults" :fields = "exportHeaders" name = "srr.xls">
                    Export to Excel
                </exportExcel>
                &nbsp;
                <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else-if="noResults && !loading" >
            <b-col sm="12">
              <div align="center">
                <strong>No Sales Cancellation Found</strong>
              </div>                    
            </b-col>
      </b-row>
  </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import wscLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup,apiWscSearch,apiWscLookUp} from '@/functions/common.vue'
import exportExcel from 'vue-json-excel'

  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };
export default 
  {
    components:{spinner,countryLookup,wscLookup,exportExcel},
    props: {
      caption: 
      {
        type: String,
        default: 'Table'
      },
      hover: 
      {
        type: Boolean,
        default: false
      },
      striped: 
      {
        type: Boolean,
        default: false
      },
      bordered: 
      {
        type: Boolean,
        default: false
      },
      small: 
      {
        type: Boolean,
        default: false
      },
      fixed: 
      {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        apiCountryLookup:apiCountryLookup,
        apiWscLookUp:apiWscLookUp,
        loading: false,
        noResults: false,
        filter: 
          {
            credit_note_number: '',
            country_id: '',
            from_date: '',
            to_date: '',
            cancellation_status_name:''
          },  
        searchResults: [],
        searchResultsFields: 
        [
          {key: 'country_code', label: 'Country Code'},
          {key: 'stock_location_name' ,label: 'Location Name'},
          {key: 'transaction_date' ,label: 'Date'},
          {key: 'credit_note_number' ,label: 'Cancellation Doc. No'},
          {key: 'old_member_id' ,label: 'IBO/Stockist ID'},
          {key: 'member_name' ,label: 'IBO/Stockist Name'},
          {key: 'cancellation_status_name' ,label: 'Approval Status'},
          {key: 'receiving_status' ,label: 'Receiving Status'},
          {key: 'elken_author_user_shortname' ,label: 'Created By'}
        ],
        currentPage: 1,
        perPage: 20,
        totalRows: 0,
        noResults: false,
        exportHeaders:
          {
            'Cancellation Doc No': 'credit_note_number',
            'Date': 'transaction_date',
            'Country': 'country_code',
            'Location': 'stock_location_name',
            'IBO/Stockist ID':'old_member_id',
            'IBO/Stockist Name':'member_name',
            'Status':'cancellation_status_name',
            'Created By':'elken_author_user_shortname',
          },
      }
    },
    methods: 
    {
      print()
          {
                var rows = []
                var row = []
                var date = new Date()
                rows.push([
                'Cancellation Doc #',
                'Date',
                'Country',
                'Location',
                'IBO/Stockist ID',
                'IBO/Stockist Name',
                'Status',
                'Created By'
                ])

                for (let key in this.searchResults)
                {
                  var data = this.searchResults[key]
                  row = [
                    data.credit_note_number, 
                    data.transaction_date,
                    data.country_code,
                    data.stock_location_name,
                    data.old_member_id,
                    data.member_name,
                    data.cancellation_status_name,
                    data.elken_author_user_shortname
                ]
                  rows.push(row)
                }
                var dd = {
                  header:{ text: 'Sales Cancellation Posting List generated on'+ " "+ date, margin: [ 5, 10, 10, 30 ],alignment: 'center',fontSize:9 },
                  pageSize: 'A4',
                  pageOrientation: 'portrait',
                  defaultStyle: {
                font: 'ukai'
              },
                  // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                  pageMargins: [30, 30, 30, 20 ],

                  content: [
                    {
                      fontSize: 8,
                      layout: 'lightHorizontalLines', // optional
                      table: 
                      {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,
                        widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: 
                          rows
                      }
                    }
                  ]
                };

                pdfMake.createPdf(dd).open();
          },
      rowClick(item)
      {
        localStorage.setItem("wsc_new.credit_note_number", item.credit_note_number)
        this.$router.push({ name: 'Sales Cancellation Entry (SC)', params: { wscNum: '_new' }}) 
      },
      getRowCount (items) 
      {
        return items.length
      },
      search()
      {
        this.noResults =true
        this.loading = true
        var sf=
        {
          "credit_note_number" :this.filter.credit_note_number,
          "country_id":this.filter.country_id,
          "from_date" :this.filter.from_date,
          "to_date" :this.filter.to_date,
          "cancellation_status_name":this.filter.cancellation_status_name
        }
        axios.post(apiWscSearch, sf,authHeader())
          .then (res => 
          {
              return res
          })
          .then (data =>
          {
      
              const resultArray = []
              const myData = data.data.data
              for (let key in myData)
              {
                  var date = myData[key].transaction_date
                  var date = new Date(date);
                  var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                  myData[key].transaction_date=result
                  resultArray.push(myData[key])
                  this.loading = false
              }
              this.searchResults = resultArray
              
              if(this.searchResults.length ==0)
              {
                  this.loading = false
                  this.noResults =true
              }
          })
          .catch(error => alert(error)) 

      },
      newWSC()
      {
        localStorage.setItem("wsc_new.credit_note_number","")
        this.$router.push({ name: 'Sales Cancellation Entry (SC)', params: { wscNum: '_new' }})
      },
      setWsc(obj)
      {
          var id
          if (obj !== null)
          {
            id = obj.id
          } 
          else
          {
              id = null
          }
          this.filter.credit_note_number = id
      },
      setCountry(obj)
      {
            var id
            if (obj !== null)
            {
              id = obj.id
            } 
            else
            {
              id = null
            }
            this.filter.country_id = id
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/wsc/wscs.vue